import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class PreventiveMaintenanceCreateService {

  constructor(private http: HttpClient) { }

  getJobList(params?: any): Observable<any> {
    return this.http.get(environment.appUrl + 'jobs', {params: params,observe: 'body', withCredentials: true});
  }

  getActiveEquipmentList(jobNumber: string): Observable<any> {
    return this.http.post(environment.appUrl + 'jobs/equipment-summary', {jobNumbersModel: [jobNumber]}, {observe: 'body', withCredentials: true});
  }

  createPM(form: any): Observable<any> {
    return this.http.post(environment.appUrl + 'pms', {
      pmdetailListModel: [form]
    }, {observe: 'body', withCredentials: true});
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/preventive-maintenance/preventive-maintenance-create/preventive-maintenance-create.service.ts